import {
    REGISTRATION_SET_TOKEN,
    REGISTRATION_SET_TENANT,
    REGISTRATION_SET_LOADING,
    REGISTRATION_SET_USER_ATTRIBUTES,
    REGISTRATION_SHOW_ADDITIONAL_FORM,
    REGISTRATION_SHOW_FORM,
    REGISTRATION_SET_ERROR_MESSAGE,
    REGISTRATION_SHOW_CONFIRMATION_FORM,
    AUTH_SHOW_RESET_PASSWORD,
    LOGIN_SHOW_NEW_PASSWORD,
    AUTH_SHOW_LOGIN,
    AUTH_SET_PASSWORD_RESET_TOKEN,
    AUTH_SET_USER,
} from '../actionTypes'

const defaultState = {
    user: null,
    username: null,
    confirmationCode: null,
    isLoading: false,
    errorMessage: '',
    token: '',
    passwordResetToken: '',
    validToken: false,
    showForm: false,
    showConfirmationForm: false,
    showTokenFields: true,
    showAdditionalForm: false,
    showLogin: true,
    showNewPassword: false,
    passwordResetRequired: false,
    showResetPassword: false,
    tenant: null,
    userAttributes: null,
}

const authReducer = (state = defaultState, action) => {
    switch (action.type) {
        case AUTH_SET_USER:
            return {
                user: action.user,
            }
        case AUTH_SHOW_LOGIN:
            return {
                ...state,
                showLogin: action.show,
                showResetPassword: !action.show,
                showNewPassword: !action.show,
                showConfirmationForm: !action.show,
                showTokenFields: action.show,
            }
        case AUTH_SET_PASSWORD_RESET_TOKEN:
            return {
                ...state,
                passwordResetToken: action.token,
            }
        case AUTH_SHOW_RESET_PASSWORD:
            return {
                ...state,
                showResetPassword: action.show,
                showLogin: !action.show,
            }
        case LOGIN_SHOW_NEW_PASSWORD:
            return {
                ...state,
                showNewPassword: action.show,
                showLogin: !action.show,
                showResetPassword: !action.show,
            }
        case REGISTRATION_SET_LOADING:
            return {
                ...state,
                isLoading: !state.isLoading,
            }
        case REGISTRATION_SET_TOKEN:
            return {
                ...state,
                token: action.value,
            }
        case REGISTRATION_SET_TENANT:
            return {
                ...state,
                tenant: action.tenant,
                showForm: true,
                showTokenFields: false,
                isLoading: false,
            }
        case REGISTRATION_SHOW_ADDITIONAL_FORM:
            return {
                ...state,
                showAdditionalForm: action.show,
                showForm: !action.show,
                showConfirmationForm: !action.show,
            }
        case REGISTRATION_SHOW_FORM:
            return {
                ...state,
                showForm: action.show,
                showAdditionalForm: !action.show,
                showConfirmationForm: !action.show,
            }
        case REGISTRATION_SET_USER_ATTRIBUTES:
            return {
                ...state,
                userAttributes: action.attributes,
            }
        case REGISTRATION_SET_ERROR_MESSAGE:
            return {
                ...state,
                errorMessage: action.message,
            }
        case REGISTRATION_SHOW_CONFIRMATION_FORM:
            return {
                username: action.username,
                confirmationCode: action.code,
                resendConfirmationCode: action.resend,
                showAdditionalForm: false,
                showForm: false,
                showLogin: false,
                showConfirmationForm: true,
            }

        default:
            return state
    }
}

export default authReducer
